import { useQuery } from 'react-query';

import { getTopFinishDateChanges as queryFn } from 'api/endPoints/getTopFinishDateChanges';

export const useQueryFinishDateChangesTableData = (params) => {
    return useQuery(['finishDateChangesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
